import {ElementRef, Injectable, InjectionToken} from "@angular/core";
import {fromEvent, merge, Observable} from "rxjs";

export let ELEMENT_TOKEN = new InjectionToken("generic.element");

export interface IElementService {
	focus(el:ElementRef);
	blur(el:ElementRef);
	isFocused(el:ElementRef);
	focusedChanged(el:ElementRef):Observable<FocusEvent>;
}

@Injectable()
export class ElementNodeService implements IElementService {
	public focus(el:ElementRef){
		// do nothing
	}

	public blur(el:ElementRef){
		// do nothing
	}

	public isFocused(){
		// do nothing
	}
	public focusedChanged(el:ElementRef):Observable<FocusEvent>{
		return null;
	}
}

@Injectable()
export class ElementBrowserService implements IElementService {
	public focus(el:ElementRef){
		el.nativeElement.focus();
	}

	public isFocused(el:ElementRef){
		return document.activeElement===el.nativeElement;
	}

	public blur(el:ElementRef){
		el.nativeElement.blur();
	}

	public focusedChanged(el:ElementRef):Observable<FocusEvent>{
		return <Observable<FocusEvent>>merge(fromEvent(el.nativeElement,'focus'),fromEvent(el.nativeElement,'blur'));
	}
}
